/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AutomatedProcessCountProcessInstances$Params {
  workflowTriggerEventProcessId: number;
}

export function automatedProcessCountProcessInstances(http: HttpClient, rootUrl: string, params: AutomatedProcessCountProcessInstances$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
  const rb = new RequestBuilder(rootUrl, automatedProcessCountProcessInstances.PATH, 'get');
  if (params) {
    rb.path('workflowTriggerEventProcessId', params.workflowTriggerEventProcessId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
    })
  );
}

automatedProcessCountProcessInstances.PATH = '/automated-process/process-instance/{workflowTriggerEventProcessId}/count';